<template>
  <el-col :xs="12" :sm="12" :lg="5" class="card-panel-col">
    <div class="card-panel" :style="`cursor:${editable?'pointer':'auto'}`" @mouseenter="hovered=true" @mouseleave="hovered=false">
      <div :style="iconWrapper" class="card-panel-icon-wrapper">
        <svg-icon :icon-class="icon" class-name="card-panel-icon" />
      </div>
      <div class="card-panel-description">
        <div class="card-panel-text">{{ text }}</div>
        <count-to :start-val="0" :end-val="number" :duration="1500" class="card-panel-num" />
      </div>
    </div>
  </el-col>
</template>

<script>
import CountTo from 'vue-count-to'
export default {
  components: {
    CountTo
  },
  props: {
    icon: {
      type: String,
      default: 'example'
    },
    text: {
      type: String,
      default: ''
    },
    number: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hovered: false
    }
  },
  computed: {
    iconWrapper () {
      return this.hovered ? { background: this.color } : { color: this.color }
    }
  }
}
</script>

<style scoped>
.card-panel-col {
  margin-bottom: 32px;
}

.card-panel {
  height: 108px;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  color: #666;
  background: #fff;
  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.05);
}
.card-panel .card-panel-icon-wrapper {
  float: left;
  margin: 14px 0 0 14px;
  padding: 16px;
  transition: all 0.38s ease-out;
  border-radius: 6px;
}
.card-panel:hover .card-panel-icon-wrapper {
  color: #fff;
}
.card-panel .card-panel-icon {
  float: left;
  font-size: 48px;
}
.card-panel .card-panel-description {
  float: right;
  font-weight: bold;
  margin: 26px;
  margin-left: 0px;
}
.card-panel .card-panel-description .card-panel-text {
  line-height: 18px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-bottom: 12px;
}
.card-panel .card-panel-description .card-panel-num {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/CountTo.vue